/**
 * Master Sheet Formula: none
 *
 * Formula:
 * =_xlfn.XLOOKUP(I4,'Material + Finish Dropdown IV.'!$G$2:$AF$2,'Material + Finish Dropdown IV.'!$G$3:$AF$29)
 *
 * Variables:
 * - I4: Material
 *
 * Notes:
 * - This formula is part of data validation and not an actual formula that we can parse.
 */

import { StandardResult } from '@calculations/utilities/result';
import type { StringListMapDataSchema } from '@snap-types/models/auto-configurator-data-set/data-schemas/map';
import { err, ok } from 'neverthrow';

type Inputs = {
  material: string;
  surfaceFinishOptions: StringListMapDataSchema;
};

export function getSurfaceFinish({
  material,
  surfaceFinishOptions,
}: Inputs): StandardResult<string[]> {
  const surfaceFinish = surfaceFinishOptions[material];

  if (!surfaceFinish) {
    return err({
      message: `Surface finish not found for ${material}`,
      context: {
        material,
        surfaceFinishOptions,
      },
    });
  }

  return ok(surfaceFinish);
}
